<template>
  <div class="q-ml-md" style="height: '100%'">
    <div class="row align">
      <ModalFiltrosContratos
        @filtrosContratos="getFiltros"
        :loadingValue="loadingValue"
      />
      <p class="text-h6 text-brand-5 text-weight-bold q-mt-md">
        Relatório de contratos
      </p>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :exportName="'Contratos'"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :cnpjName="'CNPJ'"
      @enviarRespostaEp="getRelatorioSalvo"
      @flexmonsterLoading="loadingStop"
      :salvarType="'contratos'"
    />
    <q-dialog persistent v-model="showComentarioMovimentacao">
      <q-card style="height: 220px; width: 450px">
        <q-card-section class="column">
          <span style="color: #21324a" class="mensagem-text">Aviso</span>
          <q-separator style="height: 1px; background-color: #21324a" />
        </q-card-section>

        <q-card-section style="min-height: 70px">
          <span style="color: #21324a">
            Seu relatório excedeu o tempo para geração automático, aguarde o
            link na central de notificações pra download do relatório
            completo.</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Confirmar"
            :disabled="desabilitarConfirme"
            no-caps
            icon="done"
            @click="openModal++"
            v-close-popup
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import Flexmonster from "../../relatorios/components/Flexmonster.vue";
import ModalFiltrosContratos from "../components/ModalFiltrosContratos.vue";

import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { defineComponent, ref, onMounted } from "vue";
export default defineComponent({
  name: "CompositionAPIDemo",
  components: {
    Flexmonster,
    ModalFiltrosContratos,
  },
  setup() {
    const route = useRoute();
    const id = route.params.id;
    const loadingValue = ref("");
    const store = useStore();
    const link = ref("");
    const quasar = useQuasar();
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const showComentarioMovimentacao = ref(false);
    const filtrosObject = ref(null);
    const types = ref({
      CNPJ: {
        type: "string",
      },
      Valor_Total: {
        type: "number",
      },
      Codigo_Produto: {
        type: "string",
      },
      Matricula_Usuario_Criacao: {
        type: "string",
      },
    });
    const layout = ref("flat");
    const updateLink = ref(0);
    const slice = ref({
      columns: "",
      rows: [{ uniqueName: "ProviderName" }],
      reportFilters: "",
      measures: [
        { uniqueName: "Contrato_ID" },
        { uniqueName: "Numero_Contrato" },
        { uniqueName: "Data_Inicio_Vigencia" },
        { uniqueName: "Data_Fim_Vigencia" },
        {
          uniqueName: "Valor_Total",
          aggregation: "sum",
          active: true,
          format: "currency",
        },
        { uniqueName: "Numeros_Aditivos" },
        { uniqueName: "Status" },
        { uniqueName: "Tipo_Fornecimento" },
        { uniqueName: "Categoria_Produto" },
        { uniqueName: "Grupo_Produto" },
        { uniqueName: "Codigo_Produto" },
        { uniqueName: "Descricao_Produto" },
        { uniqueName: "Numero_Linha" },
        { uniqueName: "Observacoes" },
        { uniqueName: "ID_Fornecedor" },
        { uniqueName: "Razao_Social_Fornecedor" },
        { uniqueName: "Nome_Fantasia_Fornecedor" },
        { uniqueName: "CNPJ" },
        { uniqueName: "Data_Criacao" },
        { uniqueName: "Data_Atualizacao" },
        { uniqueName: "Data_Exclusao" },
        { uniqueName: "userId" },
        { uniqueName: "Nome_Usuario_Criacao" },
        { uniqueName: "Matricula_Usuario_Criacao" },
        { uniqueName: "Perfil_Usuario_Criacao" },
        { uniqueName: "Nome_Usuario_Exclusao" },
        { uniqueName: "Matricula_Usuario_Exclusao" },
        { uniqueName: "Perfil_Usuario_Exclusao" },
        { uniqueName: "Unidades_Vinculadas" },
      ],
    });
    const formats = ref([
      {
        name: "currency",

        currencySymbol: "R$ ",
        currencySymbolAlign: "left",
        thousandsSeparator: ".",
        decimalSeparator: ",",
        decimalPlaces: 2,
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");

    const getFiltros = async (filtros) => {
      loadingValue.value = true;

      try {
        filtrosObject.value = filtros;

        const filtrosApi = {
          vendors: filtros.vendors || [],
          providerSearch: filtros.providerSearch || undefined,
          contractNumber: filtros.contractNumber || undefined,
          startDate: filtros.startDate || undefined,
          endDate: filtros.endDate || undefined,
          product: filtros.product || undefined,
          productGroups: filtros.productGroups || [],
          supplyName: filtros.supplyName || [],
          status: filtros.status || undefined,
          productCategories: filtros.productCategories || [],
        };
        const response = await store.dispatch(
          "gdcStore/getContractReport",
          filtrosApi
        );

        filtros.value = JSON.stringify(filtrosObject);
        link.value = response.data.return?.url || response.data.result?.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;
      } catch (error) {
        console.log(error);
        loadingValue.value = false;

        quasar.notify({
          message: "Erro ao gerar relatório de contratos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        // Se erro 408 ou timeout, tentar em background
        if (
          error?.response?.status == undefined ||
          error?.response?.status == 408
        ) {
          showComentarioMovimentacao.value = !showComentarioMovimentacao.value;
          getRelatorioSecundario();
        }
      }
    };
    const getRelatorioSecundario = async () => {
      loadingValue.value = true;

      try {
        const response = await store.dispatch("gdcStore/getContractReport", {
          ...filtrosObject.value,
          background: 1,
        });

        link.value = response.data.result?.url;
        updateLink.value++;
        loadingValue.value = false;
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.error("Erro no relatório secundário:", error);
        loadingValue.value = false;

        quasar.notify({
          message: "Erro ao gerar relatório em background",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };
    const relatorioLink = route.query.id;
    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          loadingValue.value = true;
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          
          layout.value = dados.value.template?.layout || "flat";
          showTotals.value = dados.value.template?.showTotals || "";
          showGrandTotals.value = dados.value.template?.showGrandTotals || "";
          
          slice.value.columns = dados.value.template?.columns || "";
          slice.value.rows = dados.value.template?.rows || [{ uniqueName: "ProviderName" }];
          slice.value.reportFilters = dados.value.template?.filtros || "";
          slice.value.measures = dados.value.template?.values || slice.value.measures;

          const filtrosSalvos = dados.value.filtros ? JSON.parse(dados.value.filtros) : {};
          filtros.value = dados.value.filtros || "";

          const novaResponse = await store.dispatch(
            "gdcStore/getContractReport",
            filtrosSalvos
          );
          
          link.value = novaResponse.data.return?.url || novaResponse.data.result?.url;
          url.value = novaResponse?.request?.responseURL;
          urlEp.value = novaResponse.data.return?.url || novaResponse.data.result?.url;
          
          gerarCsv.value = false;
          exibir.value = true;
          updateLink.value++;
          loadingValue.value = false;
        } catch (error) {
          console.log(error);
          loadingValue.value = false;
          
          quasar.notify({
            message: "Erro ao carregar relatório salvo. Os filtros podem estar incorretos.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }
      if (
        relatorioLink != "" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.return.url;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    onMounted(verificarUrl);

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    return {
      slice,
      getFiltros,
      exibir,
      link,
      loadingValue,
      filtros,
      getRelatorioSalvo,
      showGrandTotals,
      types,
      layout,
      updateLink,
      url,
      showTotals,
      urlEp,
      formats,
      loadingStop,
      gerarCsv,
      dados,
      filtrosObject,
      showComentarioMovimentacao,
    };
  },
});
</script>

<style scoped>
.align {
  align-items: center !important;
}
</style>
